import { render, staticRenderFns } from "./DescuentoPermanente.vue?vue&type=template&id=feb6048a"
import script from "./DescuentoPermanente.vue?vue&type=script&lang=js"
export * from "./DescuentoPermanente.vue?vue&type=script&lang=js"
import style0 from "./DescuentoPermanente.vue?vue&type=style&index=0&id=feb6048a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VIcon,VTextField})
